import * as BABYLON from "babylonjs";
import { GeoBoundingBox } from "./geoBoundingBox";
import { GeoPoint } from "./geoPoint";
import { Intersector } from "./intersector";
import { VectorUtils } from "./vectorUtils";

export class GeoPolygon {
    points: GeoPoint[];
    enuPoints: BABYLON.Vector2[];
    boundingBox: GeoBoundingBox;

    constructor(points: GeoPoint[]) {
        this.points = points;
        this.boundingBox = GeoBoundingBox.fromPoints(points);
        this.enuPoints = this.points.map(it => VectorUtils.toVector2(it.toEnuCoords(this.boundingBox.center)));
    }

    containsPoint(point: GeoPoint): boolean {
        if (!this.boundingBox.containsPoint(point)) {
            return false;
        }

        let center = this.boundingBox.center;
        let numIntersections = 0;

        let rayEnd = VectorUtils.toVector2(point.toEnuCoords(center));
        let rayStart = rayEnd.subtract(new BABYLON.Vector2(-100000000, 0));

        for (let i = 1; i < this.enuPoints.length; i++) {
            let segmentStart = this.enuPoints[i - 1];
            let segmentEnd = this.enuPoints[i];

            if (Intersector.intersectSegments(rayStart, rayEnd, segmentStart, segmentEnd)) {
                numIntersections++;
            }
        }

        return numIntersections % 2 == 1;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/earth/core/geoPolygon.ts